var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 41,
    viewBox: "0 0 64 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14.1885H11.9966C12.2467 14.1885 12.4879 14.0947 12.6723 13.9256L26.4091 1.33352C28.3333 -0.43034 31.4363 0.934674 31.4363 3.54498V37.4111C31.4363 39.9546 28.4697 41.3441 26.5158 39.7157L12.6906 28.1948C12.5109 28.045 12.2844 27.963 12.0504 27.963H3C1.34315 27.963 0 26.6199 0 24.963V17.1885C0 15.5316 1.34314 14.1885 3 14.1885ZM39.6657 32.3343C38.7781 31.4468 38.7781 30.0078 39.6657 29.1202L48.2859 20.5L39.6657 11.8798C38.7781 10.9922 38.7781 9.55322 39.6657 8.66567C40.5532 7.77811 41.9922 7.77811 42.8798 8.66567L51.5 17.2859L60.1202 8.66567C61.0078 7.77811 62.4468 7.77811 63.3343 8.66567C64.2219 9.55322 64.2219 10.9922 63.3343 11.8798L54.7141 20.5L63.3343 29.1202C64.2219 30.0078 64.2219 31.4468 63.3343 32.3343C62.4468 33.2219 61.0078 33.2219 60.1202 32.3343L51.5 23.7141L42.8798 32.3343C41.9922 33.2219 40.5532 33.2219 39.6657 32.3343Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound-off.7c6df445400c49f3fe18c0d5cfee6f5b.svg";
export { ForwardRef as ReactComponent };